import { render, staticRenderFns } from "./LayoutThemeModal.vue?vue&type=template&id=61ea0d6d&scoped=true"
import script from "./LayoutThemeModal.vue?vue&type=script&lang=js"
export * from "./LayoutThemeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ea0d6d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61ea0d6d')) {
      api.createRecord('61ea0d6d', component.options)
    } else {
      api.reload('61ea0d6d', component.options)
    }
    module.hot.accept("./LayoutThemeModal.vue?vue&type=template&id=61ea0d6d&scoped=true", function () {
      api.rerender('61ea0d6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modals/LayoutThemeModal.vue"
export default component.exports